var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertsWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.315,
    height: 18,
    viewBox: "0 0 18.315 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160691",
    "data-name": "Group 160691",
    transform: "translate(-463.685 -297)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    width: 18,
    height: 18,
    transform: "translate(464 297)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M12.11,4.628l-.991-1.652a1.555,1.555,0,0,0-2.14-.527,1.607,1.607,0,0,0-.527.527L1.843,14.013a1.56,1.56,0,0,0,.574,2.132,1.637,1.637,0,0,0,.763.212H16.4a1.559,1.559,0,0,0,1.33-2.344l-3.8-6.341",
    transform: "translate(462.912 295.74)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3267",
    "data-name": "Group 3267",
    transform: "translate(468.295 301.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M11.3,8.806l-3.535,5.9a.833.833,0,0,0,.3,1.138.814.814,0,0,0,.406.112h7.069a.83.83,0,0,0,.823-.843.814.814,0,0,0-.112-.406l-3.535-5.9a.836.836,0,0,0-1.432,0Z",
    transform: "translate(-7.649 -8.404)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M0,0V1.711",
    transform: "translate(4.359 2.523)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    x2: 0.01,
    transform: "translate(4.359 5.945)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 0.448,
    cy: 0.448,
    r: 0.448,
    transform: "translate(475.58 301.476)",
    fill: "#787f88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsWhiteIcon);
export default __webpack_public_path__ + "static/media/alerts-white-icon.09c1083c0a977fdc6c73c555c78b78c1.svg";
export { ForwardRef as ReactComponent };